export class SendMessageToAI400Response {
    'error';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SendMessageToAI400Response.attributeTypeMap;
    }
    constructor() {
    }
}
